import React from 'react';
import InputMask from 'react-input-mask';
import {
  FormControl,
  FormHelperText,
  type InputBaseComponentProps,
  InputLabel,
  NoSsr,
} from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';

import type { InputPhoneControlProps } from '../types';

const MaskedInput = React.forwardRef(function MaskedInput(
  {
    mask = '',
    ...rest
  }: Omit<InputBaseComponentProps, 'children'> & {
    mask?: string | (string | RegExp)[];
  },
  ref: React.LegacyRef<InputMask>
) {
  return <InputMask mask={mask} ref={ref} {...rest} />;
});

export default React.forwardRef<HTMLInputElement, InputPhoneControlProps>(
  function InputPhoneControl({ error, helperText, ...props }, ref) {
    return (
      <NoSsr>
        <FormControl fullWidth>
          {props.label && (
            <InputLabel error={error} htmlFor={props.name}>
              {props.label}
            </InputLabel>
          )}

          <OutlinedInput
            {...props}
            error={error}
            inputComponent={MaskedInput}
            inputProps={{ mask: '+1 (999) 999-9999', ...props.inputProps }}
            inputRef={ref}
          />
          <FormHelperText error={error}>{helperText}</FormHelperText>
        </FormControl>
      </NoSsr>
    );
  }
);
